import { bem } from '@/utilities';
import React from 'react';

export const Loading: React.FC = () => {
  return (
    <div className='loading'>
      <div className={bem('loading', 'content')}>
        {[...Array(8)].map((_, i) => (
          <div className={bem('loading', 'content-spinner')} key={i}></div>
        ))}
      </div>
    </div>
  );
};
